"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getMaxFavoriteSuggestionCounts_1 = require("./getMaxFavoriteSuggestionCounts");
var isInFavorites_1 = require("owa-mail-favorites-store/lib/selectors/isInFavorites");
var owa_session_store_1 = require("owa-session-store");
/**
 * Get the favorite category suggestions based on the find text that user types
 * @param findText the find text in the favorite picker search box
 * @return an array of favorite category suggestions
 */
function getFavoriteCategorySuggestions(findText) {
    // the MasterCategoryList can be null for shared folders
    var masterCategoryList = owa_session_store_1.getUserConfiguration().MasterCategoryList;
    var categorySuggestions = [];
    if (!masterCategoryList) {
        return categorySuggestions;
    }
    // Use the CategoryMetaData list instead of master list for suggestions
    // VSO 23344 - MRU -  start storing the last used time in categoryMetadata and start using it
    for (var _i = 0, _a = masterCategoryList.MasterList; _i < _a.length; _i++) {
        var categoryEntry = _a[_i];
        if (categoryEntry.Name.trim() != '' &&
            categoryEntry.Name.toLocaleLowerCase().indexOf(findText.toLocaleLowerCase()) >= 0 &&
            !isInFavorites_1.isCategoryInFavorites(categoryEntry.Id)) {
            // Add the category to suggestion list if
            // - the category name contains the find text
            // - and the id(category guid) is not present in the favorites
            // - and the category name is not empty
            categorySuggestions.push({
                data: categoryEntry.Name,
                id: categoryEntry.Id,
                type: 3 /* Category */,
                relevance: 0 /* Relevance scores will be supplied by providers in the future */,
            });
        }
    }
    // Sort the suggestions by prefix, i.e if the category name contains the find text as prefix
    var maxCategorySuggestions = getMaxFavoriteSuggestionCounts_1.default().category;
    categorySuggestions
        .sort(function (a, b) {
        return (a.data.toLocaleLowerCase().indexOf(findText) -
            b.data.toLocaleLowerCase().indexOf(findText));
    })
        .splice(maxCategorySuggestions);
    return categorySuggestions;
}
exports.default = getFavoriteCategorySuggestions;
//# sourceMappingURL=getFavoriteCategorySuggestions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-find-favorites/lib/actions/helpers/getFavoriteCategorySuggestions.js
// module id = 6276
// module chunks = 68